<script setup lang="ts">

import { inject, ref } from "vue";
import BaseDialog from "@/components/base/BaseDialog.vue";
import BaseButton from '@/components/base/BaseButton.vue';
import { useForm } from 'vee-validate';
import { useI18n } from 'vue-i18n';
import { bootstrap } from "vue-gtag";
import { VueCookies } from "vue-cookies";
import { useTracker } from "@/composables/useTracker";

const cookies = inject<VueCookies>('$cookies')

// REFS
const { t } = useI18n();
const cookieConsentDialog = ref<InstanceType<typeof BaseDialog>>();

const { handleSubmit, meta } = useForm();
const { track } = useTracker();

// FUNCTIONS
function openDialog() {
    track({ event: 'cookie_consent_view' });
    cookieConsentDialog.value?.openDialog();
}

function closeDialog() {
    cookieConsentDialog.value?.closeDialog();
}

const accept = handleSubmit(() => {
    bootstrap().then((gtag) => {
        cookies.set('consent', 1)
    })
    closeDialog();
});

const refuse = handleSubmit(() => {
    cookies.set('consent', 0)
    closeDialog();
});


defineExpose({
    openDialog,
    closeDialog,
});

</script>

<template>
    <BaseDialog ref="cookieConsentDialog" :is-dirty="true" :position="'bottom'" :have-close-button="false" class="cookie-consent">
        <template v-slot:title>
            <div class="cookie-consent__title">
                {{ t('dialog.cookieConsent.title') }}
            </div>
        </template>
        <template v-slot:content>
            <div>
                {{ t('dialog.cookieConsent.description') }}
            </div>
            <div class="row no-wrap justify-end q-gutter-md">
                <BaseButton is-transparent class="primary-reverse" @click="refuse">{{ t('dialog.cookieConsent.accept-only') }}</BaseButton>
                <BaseButton color="primary" @click="accept">{{ t('dialog.cookieConsent.accept-all') }}</BaseButton>
            </div>
        </template>
    </BaseDialog>
</template>

<style lang="scss">
.cookie-consent {

    .q-card {
        border-radius: 10px;
        padding: $space-sm;

        &__section {
            align-items: start !important;
        }
    }

    .q-btn {
        font-weight: bold;
        width: 190px;
    }

    .base-dialog__content {
        display: flex;
        gap: $space-md;
    }

    &__title {
        font-size: $body-text;
        font-weight: bold;
    }

    .primary-reverse {
        border: 1px solid $color-primary-darken;
        color: $color-primary-darken;
    }
}
@media screen and (max-width: $breakpoint-sm) {
    .cookie-consent {
        .q-btn {
            font-size: 12px;
            width: 160px;
        }
    }
}
</style>